/* eslint-disable comma-dangle */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useLocation } from 'react-router'
import { Grid } from '@material-ui/core/'
import { CenterContainer, LeftContainer, RightContainer, FeadbackMeet, FailedReview, ChatHeaderUser } from './components'
import './index.scss'
import apiChat from '../../api/chat'
import c from 'classnames'
import {
  setChatSchedules,
  setChatRequests,
  setChatMeetings,
  setMeeting,
  setGetChats,
  setChatUser,
  setChatNotification,
} from '../../modules/chatCategory/actions'
import { useDebouncedCallback } from 'use-debounce'

const Chats = () => {
  const [openReview, setOpenReview] = useState(false)
  const [openFailed, setOpenFailed] = useState(false)
  const [authorUser, setAuthorUser] = useState({})
  const [userMess, setUserMess] = useState([])
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { user } = useSelector(({ session }) => session)
  const { chatUser, meeting, typeNotification, isMobile, getChatsUpdate } = useSelector(({ chat }) => chat)
  const chatClass = document.querySelector('.wrapperUserMessages')
  const [openUserMobileModal, setOpenUserMobileModal] = useState(false)
  const { chatId } = useParams()
  const [aceptRewiev, setAceptRewiev] = useState(false)
  const { pathname } = useLocation()
  const [nameAbout, setNameAbout] = useState('')

  const debouncedSeeMessage = useDebouncedCallback(
    () => {
      apiChat.seenMessage(user?.accessKey, chatUser?.lastMessage?.uuid, chatUser?.uuid)
    }, 1000
  )

  const getUserMessages = () => {
    apiChat.getMessages(user?.accessKey, chatUser?.uuid)
      .then(res => {
        if (res?.data?.messages?.length) {
          setUserMess(res?.data?.messages?.reverse())
        }
      }).catch(error => console.error(error))
      .finally(() => setLoading(false))
  }

  const getMeeting = () => {
    if (chatUser?.meeting?.uuid) {
      apiChat.getMeeting(user?.accessKey, chatUser?.meeting?.uuid)
        .then(data => {
          dispatch(setMeeting(data?.data?.meeting))
        })
    }
  }

  const getListChats = () => {
    dispatch(setGetChats(false))
    apiChat?.getChats(user?.accessKey, 'scheduled')
      .then(({ data }) => {
        if (data?.chats?.length && chatUser?.uuid) {
          dispatch(setChatSchedules(data?.chats))
          const newChatUser = data?.chats?.find(i => i?.uuid === chatUser?.uuid) || {}
          if (newChatUser?.uuid) {
            dispatch(setChatUser(newChatUser))
          }
        } else if (data?.chats?.length) {
          dispatch(setChatSchedules(data?.chats))
        } else {
          dispatch(setChatSchedules([]))
        }
      })
    apiChat?.getChats(user?.accessKey, 'request')
      .then(({ data }) => {
        if (data?.chats?.length && chatUser?.uuid) {
          dispatch(setChatRequests(data?.chats))
          const newChatUser = data?.chats?.find(i => i?.uuid === chatUser?.uuid) || {}
          if (newChatUser?.uuid) {
            dispatch(setChatUser(newChatUser))
          }
        } else if (data?.chats?.length) {
          dispatch(setChatRequests(data?.chats))
        } else {
          dispatch(setChatRequests([]))
        }
      })
    apiChat?.getChats(user?.accessKey, 'meeting')
      .then(({ data }) => {
        if (data?.chats?.length && chatUser?.uuid) {
          dispatch(setChatMeetings(data?.chats))
          const newChatUser = data?.chats?.find(i => i?.uuid === chatUser?.uuid) || {}
          if (newChatUser?.uuid) {
            dispatch(setChatUser(newChatUser))
          }
        } else if (data?.chats?.length) {
          dispatch(setChatMeetings(data?.chats))
        } else {
          dispatch(setChatMeetings([]))
        }
      })
  }

  const authorName = () => {
    if (chatUser?.users?.[0]?.uuid !== user?.user?.uuid) {
      setAuthorUser(chatUser?.users?.[0])
    } else if (chatUser?.user?.[1]?.uuid !== user?.user?.uuid) {
      setAuthorUser(chatUser?.users[1])
    }
  }

  const deleteUserChat = () => {
    setUserMess(null)
    dispatch(setChatUser({}))
    setAuthorUser(null)
  }

  useEffect(() => {
    if (user?.accessKey) {
      getListChats()
    }
  }, [user?.accessKey])

  useEffect(() => {
    if (getChatsUpdate) {
      getListChats()
      if (chatUser?.uuid) {
        getUserMessages()
        debouncedSeeMessage()
        getMeeting()
      }
    }
  }, [getChatsUpdate, chatUser])

  useEffect(() => {
    if (chatUser?.uuid) {
      getUserMessages()
      debouncedSeeMessage()
      authorName()
      getMeeting()
      chatUser?.users?.filter(i => i?.uuid !== user?.user?.uuid ? setNameAbout(i?.name) : null)
    }
  }, [chatUser])

  useEffect(() => {
    if (typeNotification?.type === 'meeting_review') {
      setOpenReview(true)
      dispatch(setChatNotification({ type: '', name: typeNotification?.name }))
    }
  }, [typeNotification?.type])

  useEffect(() => {
    setTimeout(() => {
      if (pathname?.split('/')?.[4] === 'review') {
        if (!aceptRewiev) {
          setOpenReview(true)
        }
      }
    }, 1500)
  }, [pathname, aceptRewiev])

  useEffect(() => {
    if (userMess?.length) {
      setTimeout(() => {
        chatClass?.scrollTo(0, chatClass?.offsetHeight + 100000000)
      }, 500)
    }
  }, [userMess])

  useEffect(() => {
    if (!userMess?.length && chatUser?.uuid) {
      setLoading(true)
    }
  }, [userMess, chatUser])

  useEffect(() => {
    if (!chatUser?.uuid) {
      setUserMess([])
    }
  }, [chatUser])

  useEffect(() => {
    if (chatId) {
      apiChat?.getChatById(chatId, user?.accessKey)
        .then(({ data }) => dispatch(setChatUser({ ...data?.chat })))
    }
  }, [chatId])

  useEffect(() => {
    if (chatUser?.status === 'meeting') {
      if (chatUser?.meeting?.uuid) {
        if (chatUser?.meeting?.status === 'requested') {
          setOpenUserMobileModal(true)
        }
      }
    }
  }, [chatUser?.status])

  useEffect(() => {
    if (meeting?.reviews?.length) {
      setAceptRewiev(!!meeting?.reviews?.find(({ userUuid }) => userUuid === user?.user?.uuid))
    }
  }, [meeting?.reviews])

  return (
    <Grid className='wrapperChatContainer'>
      {isMobile && chatUser?.uuid && (
        <ChatHeaderUser
          user={user}
          chatUser={chatUser}
          authorUser={authorUser}
          deleteUserChat={deleteUserChat}
          openUserMobileModal={openUserMobileModal}
          setOpenUserMobileModal={setOpenUserMobileModal}
        />
      )}
      {!aceptRewiev && (
        <>
          <FeadbackMeet
            getMeeting={getMeeting}
            setOpenFailed={setOpenFailed}
            openReview={openReview}
            setOpenReview={setOpenReview}
            name={nameAbout}
            accessKey={user?.accessKey}
            meeting={meeting}
          />
          <FailedReview
            getMeeting={getMeeting}
            openReview={openFailed}
            setOpenReview={setOpenFailed}
            name={nameAbout}
            accessKey={user?.accessKey}
            meeting={meeting}
          />
        </>
      )}
      <Grid className={c('wrapperChatBox', !chatUser?.uuid && isMobile && 'newiWrapperChatBoxMobile')}>
        {isMobile ? (
          chatUser?.uuid ? (
            <CenterContainer
              loading={loading}
              userMess={userMess}
              setUserMess={setUserMess}
              openUserMobileModal={openUserMobileModal}
              setOpenUserMobileModal={setOpenUserMobileModal}
            />
          ) : <LeftContainer />
        ) : (
          <>
            <LeftContainer />
            <CenterContainer
              loading={loading}
              userMess={userMess}
              setUserMess={setUserMess}
            />
            <RightContainer getMeeting={getMeeting} />
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default Chats
